import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Platform from "@/pages/Platform";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import ManageDemo from "@/pages/ManageDemo";
import ManagedServices from "@/pages/ManagedServices";
import ManagedServiceDetail from "@/pages/ManagedServiceDetail";
import Assessment from "@/pages/Assessment";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App noise">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/manage-demo/:leadId" element={<ManageDemo />} />
          <Route path="/managed-services" element={<ManagedServices />} />
          <Route path="/managed-services/:slug" element={<ManagedServiceDetail />} />
          <Route path="/assessment" element={<Assessment />} />
        </Routes>
        <Footer />
        <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#ffffff", border: "1px solid rgba(8,145,178,0.35)", color: "#18181b", borderRadius: 0 } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
